"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelpStandardProjects = void 0;
const vue_1 = require("vue");
const Card_1 = require("./../card/Card");
const CardName_1 = require("./../../CardName");
exports.HelpStandardProjects = vue_1.default.component('help-standard-projects', {
    components: {
        Card: Card_1.Card,
    },
    methods: {
        getBasicStandardProjects: () => [
            CardName_1.CardName.SELL_PATENTS_STANDARD_PROJECT,
            CardName_1.CardName.POWER_PLANT_STANDARD_PROJECT,
            CardName_1.CardName.ASTEROID_STANDARD_PROJECT,
            CardName_1.CardName.AQUIFER_STANDARD_PROJECT,
            CardName_1.CardName.GREENERY_STANDARD_PROJECT,
            CardName_1.CardName.CITY_STANDARD_PROJECT,
        ],
        getExpansionStandardProjects: () => [
            CardName_1.CardName.AIR_SCRAPPING_STANDARD_PROJECT,
            CardName_1.CardName.BUILD_COLONY_STANDARD_PROJECT,
            CardName_1.CardName.BUFFER_GAS_STANDARD_PROJECT,
        ],
        getFanMadeStandardProjects: () => [
            CardName_1.CardName.MOON_COLONY_STANDARD_PROJECT,
            CardName_1.CardName.MOON_MINE_STANDARD_PROJECT,
            CardName_1.CardName.MOON_ROAD_STANDARD_PROJECT,
        ],
    },
    template: `
    <div class="help-standard-projects-container">

      <h2 v-i18n>Standard Projects</h2>
      <div class="cardbox" v-for="card in getBasicStandardProjects()">
        <Card :card="{'name': card}" />
      </div>

      <h2 v-i18n>Standard Projects from Expansions and Solo Mode</h2>
      <div class="cardbox" v-for="card in getExpansionStandardProjects()">
        <Card :card="{'name': card}" />
      </div>

      <h2 v-i18n>Standard Projects from Fan-made Expansions</h2>
      <div class="cardbox" v-for="card in getFanMadeStandardProjects()">
        <Card :card="{'name': card}" />
      </div>

    </div>
    `,
});
//# sourceMappingURL=HelpStandardProjects.js.map